"use strict";

var PyDefUtils = require("PyDefUtils");

module.exports = function(pyModule) {

	pyModule["DesignHtmlTemplate"] = Sk.misceval.buildClass(pyModule, function($gbl, $loc) {

        $loc["__init__"] = new Sk.builtin.func(PyDefUtils.withRawKwargs(function(kwargs, self) {
            self._anvil.whereWillItLand = function(x, y, width, height, mouseX, mouseY) {

            	// Landing priority algorithm:
            	//    If we're actually in a drop zone, do what the (innermost) drop zone says (as
            	//    specified by attributes on the drop-zone element). These directives are performed
            	//    in the following order of priority:
            	//
            	//    A drop zone can instruct us to:
            	//    * Pick the closest top-level container matching a CSS selector and act as though
            	//      we are over that (ie redirect the whereWillItLand call)
            	//      (anvil-drop-container="<selector>")
            	//    * Pick the closest drop zone matching a CSS selector and act though we are over
            	//      that (anvil-drop-redirect="<selector>". If selector begins with a '>', it will
            	//      be searched downwards from this element as opposed to the panel as a whole)
            	//    * Drop into an implicit slot and index (determined from the innermost anvil-slot
            	//      or anvil-slot-repeat element - if no such element is found, the the component
            	//      will be dropped at the end of the slot named by anvil-drop-slot (or "default")
            	//      if not specified.
            	//      (anvil-drop-here)
            	//    * Drop into a named slot
            	//      (anvil-drop-slot="<slot name>")

            	var getEstPos = function(elt) {
            		if (elt.length == 0) { elt = self._anvil.element; }
            		return {x: elt.offset().left, y: elt.offset().top, width: elt.outerWidth(), height: elt.outerHeight()};
            	};

            	var getClosestElt = function(elts, x, y) {
            		var closest = null;
            		var minSqDist = null;
            		for (var i=0; i < elts.length; i++) {
            			var elt = $(elts[i]);
            			var offset = elt.offset();
            			offset.right = offset.left + elt.outerWidth();
            			offset.bottom = offset.top + elt.outerHeight();
            			var ydist = (offset.top > y) ? (offset.top - y) : (offset.bottom < y) ? (y - offset.bottom) : 0;
            			var xdist = (offset.left > x) ? (offset.left - x) : (offset.right < x) ? (x - offset.right) : 0;
            			var sqDist = xdist * xdist + ydist * ydist;
            			if (minSqDist === null || sqDist < minSqDist) {
            				minSqDist = sqDist;
            				closest = elt;
            			}
            		}
            		return closest;
            	};

            	var getClosest = function(startElt, selector, x, y) {
            		var searchFrom = self._anvil.element;
            		if (/^>/.test(selector)) {
            			searchFrom = startElt;
            			selector = selector.substring(1);
            		}
            		return getClosestElt(searchFrom.find(selector).filter(":visible").filter(function() {
            			return $(this).parents(".anvil-designer-component-namespace").length == 0 && !$(this).is(".anvil-designer-component-namespace");
            		}), x, y);
            	};

            	var attemptRedirect = null;

            	var returnValForSlotNew = function(slotName, elt) {
            		return {
            			childIdx: self._anvil.components.length,
            			redirectToElement: attemptRedirect,
            			layoutProperties: {slot: slotName},
            			estimatedPosition: getEstPos(elt)
            		};
            	};

            	var visitedDropZones = $(); // Prevent infinitely redirecting drop zones.
            	// Start by finding the innermost drop zone we are over.

				var e = $(document.elementFromPoint(mouseX, mouseY));
				while (e.is(".anvil-custom-component") || e.parents(".anvil-custom-component").length != 0) {
					e = e.parent();
				}

				var tryingDefault = false;
				if (self._anvil.element.has(e).length == 0) { e = $(); } // in which case we fall straight to default
				//console.log("Starting from", e);
				while (true) {
					//console.log("Checking:", e);
					var container = e.attr("anvil-drop-container");
					if (container !== undefined && !attemptRedirect) {
						if (!container) {
							container = ">.anvil-container";
						}
						//console.log("Redirecting to container with selector:", container);
						var newE = getClosest(e, container, mouseX, mouseY);
						//console.log("Closest container is", newE);
						if (newE && newE.is(".anvil-container") && newE.data("anvil-py-component")) {
							attemptRedirect = newE;
						}
					}

					var redirect = e.attr("anvil-drop-redirect");
					if (redirect) {
						//console.log("Redirecting to slot with selector:", redirect);
						var newE = getClosest(e, redirect, mouseX, mouseY);
						//console.log("Closest matching slot is", newE, "; previously visited", visitedDropZones);
						if (newE && !visitedDropZones.is(newE)) {
							visitedDropZones = visitedDropZones.add(newE);
							e = newE;
							continue;
						}
					}

					var here = e.attr("anvil-drop-here");
					if (here !== undefined) {
						// Try to find an implicit target

						//console.log("Attempting implicit drop");

						var repE = e;
						var slotName;
						while (true) {
							if (repE.is(self._anvil.element)) {
								//console.log("Implicit drop failed");
								break;
							}

							var simpleSlot = repE.attr("anvil-slot");
							if (simpleSlot) {
								//console.log("Found simple slot:", simpleSlot);
								return returnValForSlotNew(simpleSlot, repE);
							}

							var repeatSlot = repE.attr("anvil-slot-repeat") || repE.attr("anvil-slot-repeated");
							if (repeatSlot) {
								//console.log("Found repeater slot:", repeatSlot);
								// Great! Now find our index within this repeater
								var component = repE.find(".anvil-component").not(repE.find(".anvil-container .anvil-component")).first();
								
								var childIdx = self._anvil.components.length;
								var pyComponent = component.data("anvil-py-component");
								for (var i in self._anvil.components) {
									if (self._anvil.components[i].component === pyComponent) {
										childIdx = i;
										//console.log("Inserting at index", i);
										break;
									}
								}

								return {
									childIdx: childIdx,
									redirectToElement: attemptRedirect,
									layoutProperties: {slot: repeatSlot},
									estimatedPosition: getEstPos(e)
								};
							}

							repE = repE.parent();
						}
					}

					var slotName = e.attr("anvil-drop-slot");
					if (slotName) {
						//console.log("Dropping at end of slot:", slotName);
						return returnValForSlotNew(slotName, e);
					}

					// Okay, nothing matched this go around.
					if (tryingDefault) {
						// This was our last gasp; give up
						return returnValForSlotNew("default", e);
					} else if (e.length == 0 || e.is(self._anvil.element)) {
						// We didn't hit anything on the way up; try the default drop
						tryingDefault = true;
						e = self._anvil.element.children("[anvil-drop-default]").first();
					} else {
						e = e.parent();
					}

					//console.log("Progressing up to", e);
				}

            };
            
            // Copied to DesignHtmlPanel and DesignHtmlTemplate (ew)
            self._anvil.setLayoutProperties = (pyChild, layoutProperties) => {
                let slot;
                if ("slot" in layoutProperties) {
                    slot = layoutProperties["slot"];
                    pyChild._anvil.element.detach();
                    if (pyChild._anvil.parent.removeFn) pyChild._anvil.parent.removeFn();
                    self._anvil.addComponentToDom(self, pyChild, slot);
                } else {
                    slot = self._anvil.childLayoutProps[pyChild._anvil.componentSpec.name].slot;
                }

                const ps = {};
                ps[pyChild._anvil.componentSpec.name] = { slot: slot, data_binding: layoutProperties["data_binding"] };
                return ps;
            };


		}));
    }, "DesignHtmlTemplate", [pyModule["HtmlTemplate"]]);
};

